import mergeClasses from '../../../../utils/shallowMerge';
import AccountHeader from '../accountHeaderMobile';
import AccountNavigation from '../accountNavigation';
import defaultClasses from './AccountPage.module.scss';
import app from '@frontastic/catwalk/src/js/app/app';
import ShapesSDK from '@omneo/shapes-sdk';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import { theme } from './_vars';
import { useHistory, useLocation } from 'react-router-dom';
import proxyFetch from '@frontastic/bridge/js/fetch';

const AccountPage = ({
  children,
  activeMenu,
  userName,
  goBackTitle,
  goBackAction = () => {},
  redirect = false,
  onlyWrap = false,
  customerNumber,
  customClasses = {},
}) => {
  const isMobile = useMedia('(max-width: 767px)', false);
  const isDesktop = useMedia('(min-width: 1441px)', true);
  const isTablet = useMedia('(min-width: 1025px) and (max-width: 1440px)', false);
  const isMobileBreadCrumbs = useMedia('(max-width: 1024px)', false);
  const tabletRedirectValue = useMedia('(min-width: 768px)', false);
  const styles = mergeClasses(defaultClasses, customClasses);
  const accountId = customerNumber;
  const [token, setToken] = useState();

  const location = useLocation();

  const dispatch = useDispatch();
  const { omneo } = useSelector((state) => state.app.context.project.configuration);

  useEffect(() => {
    const bread = document.querySelector('[aria-label="breadcrumbs"]');
    const commonStylesBreadcrumbs = {
      width: '100%',
      maxWidth: '1690px',
    };
    const objStyles = {
      [isDesktop]: {
        ...commonStylesBreadcrumbs,
        margin: '0 auto',
        paddingLeft: '80px',
      },
      [isMobileBreadCrumbs]: {
        ...commonStylesBreadcrumbs,
        paddingLeft: '20px',
      },
      [isTablet]: { ...commonStylesBreadcrumbs, paddingLeft: '40px' },
    }[true];
    Object.assign(bread.style, objStyles);
  }, [isDesktop, isTablet, isMobileBreadCrumbs]);

  useEffect(() => {
    if (accountId) {
      proxyFetch(`/custom_api/commercetools/customer/getOmneoToken`, { method: 'POST' })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then((body) => {
          if (!body.data?.token) {
            return;
          }
          setToken(body.data.token);
          dispatch({
            type: 'common.omneo.access',
            data: { apiToken: body.data.token },
          });
        });
    }
  }, []);

  useEffect(() => {
    if (tabletRedirectValue && location.pathname === '/account') {
      app.getRouter().history.push('/account/profile');
    }
  }, [tabletRedirectValue]);

  useEffect(() => {
    if (token && accountId) {
      const client =
        window && window.ShapesSDKClient
          ? window.ShapesSDKClient
          : ShapesSDK.init({
              url: `https://api.${omneo.tenant}.getomneo.com/id`,
              token: token,
              logging: true,
            });
      if (client && client.ready) {
        client.hydrate('profile');
      }
      dispatch({ type: 'common.omneo.access', data: { client } });
    }
  }, [token]);

  const omneoAccountLink = useMemo(
    () =>
      accountId &&
      `https://my.${theme.toLowerCase()}.com.au/login?token=${btoa(
        token,
      )}&mode=null&enableAppointment=null&externalRedirect=null`,
    [token],
  );

  const onChangeGoBack = () => {
    goBackAction && goBackAction();
    redirect && app.getRouter().push('Frontastic.Frontend.Master.Account.index');
  };

  return (
    <>
      {isMobile && !onlyWrap && <AccountHeader title={goBackTitle} action={onChangeGoBack} />}
      <span className={defaultClasses.accountPageContent}>
        <div className={!onlyWrap ? styles.accountPageContainer : ''}>
          <div className={styles.leftSide}>
            <AccountNavigation
              omneoAccountLink={accountId && omneoAccountLink}
              userName={userName}
              activeMenu={activeMenu}
              accountId={accountId}
              omneo={omneo}
              token={token}
            />
          </div>
          <div className={styles.rightSide}>
            {typeof children === 'function' ? children({ omneoAccountLink: omneoAccountLink }) : children}
          </div>
        </div>
      </span>
    </>
  );
};

export default AccountPage;
